import Select from 'component/part/Select';

export type SelectTimeProps = Readonly<{
  startHour?: number;
  minuteInterval?: number;
  value?: { hour?: number, minute?: number };
  disabled?: boolean;
  onChange: (type: 'hour' | 'minute', value: number) => void | Promise<void>;
}>;

const style = {
  layout: {
    display: 'flex',
    gap: '0.5rem',
    '& > span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '0.1rem',
    },
  },
};

const shapeNumber = (value?: number) => value ? `${value < 10 ? '0' : ''}${value}` : '00';

const SelectTime = (props: SelectTimeProps) => {
  const startHour = props.startHour || 7;
  const hourList = Array(24 - startHour)
    .fill(null)
    .map((_, index) => ({
      value: startHour + index,
      label: shapeNumber(startHour + index),
    }));
  const minuteInterval = props.minuteInterval || 5;
  const minuteCount = Math.ceil(60 / minuteInterval);
  const minuteList = Array(minuteCount)
    .fill(null)
    .map((_, index) => ({
      value: minuteInterval * index,
      label: shapeNumber(minuteInterval * index),
    }));
  const selectedHour = hourList.find(({ value }) => value === props.value?.hour);
  const selectedMinute = minuteList.find(({ value }) => value === props.value?.minute);

  const onChangeTime = async (targetType: 'hour' | 'minute', value: number) => {
    if (!props.disabled) {
      await props.onChange(targetType, value);
    }
  };

  return <div css={style.layout}>
    <Select
      list={hourList}
      labelKey='label'
      value={selectedHour}
      disabled={props.disabled}
      onChange={(item) => onChangeTime('hour', item?.value || 0)}
    />
    <span>:</span>
    <Select
      list={minuteList}
      labelKey='label'
      value={selectedMinute}
      disabled={props.disabled}
      onChange={(item) => onChangeTime('minute', item?.value || 0)}
    />
  </div>;
};

export default SelectTime;
